// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'users-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path
      fill='currentColor'
      d='M2.89 6.078a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0zM5.8 9.9a4.95 4.95 0 0 1 4.95 4.95c0 .05-.002.1-.004.15H.854c-.002-.05-.004-.1-.004-.15A4.95 4.95 0 0 1 5.8 9.9z'
    />
    <path d='M10.666 7.672a2.39 2.39 0 1 0 4.781 0 2.39 2.39 0 0 0-4.781 0zm1.034 3.501a3.914 3.914 0 0 1 5.269 3.67' />
  </g>
);

export const viewBox = '0 0 18 18';
